import React from 'react';
import * as styles from './styles/styles.module.scss';
import { GiveOrganization } from './organizations';

type OrganizationProps = {
  org: GiveOrganization;
};

const Organization = ({ org }: OrganizationProps): JSX.Element => {
  const { name, desc } = org;
  return (
    <div className={styles.orgContainer}>
      <img src={org.iconSrc} alt="" className={styles.orgIcon} loading="lazy" />
      <div className={styles.orgName}>{name}</div>
      <div className={styles.orgDesc}>{desc}</div>
    </div>
  );
};

export { Organization as default, OrganizationProps };
